import { render, staticRenderFns } from "./DeliveryTrdTll.vue?vue&type=template&id=769a671a&scoped=true&"
import script from "./DeliveryTrdTll.vue?vue&type=script&lang=js&"
export * from "./DeliveryTrdTll.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTrdTll.vue?vue&type=style&index=0&id=769a671a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a671a",
  null
  
)

export default component.exports